import React from 'react';
import { statutLabel } from './constants';

export default function StatutBadge({ statut }) {
  return <span className={`mnt-badge mnt-st-${statut}`}>{statutLabel(statut)}</span>;
}
